<template>
  <v-card class="mb-2">
    <v-card-title primary-title class="warning lighten-2">
      {{ label }}
    </v-card-title>
    <v-card-text class="pt-2">
      <v-row>
        <v-col cols="12" md="6">
          <v-col cols="12">
            <v-card elevation="2" outlined shaped>
              <v-card-title
                >งานที่ต้องการสมัคร <v-spacer></v-spacer
                ><v-btn color="info" large @click="dialog_showjob = true"
                  ><v-icon left>mdi-plus-circle-outline</v-icon> เลือกงาน</v-btn
                ></v-card-title
              >
              <v-list>
                <v-list-item-group
                  v-model="$store.state.list_job_id"
                  color="primary"
                  v-if="$store.getters.get_selJob.length > 0"
                >
                  <v-list-item
                    v-for="(item, i) in $store.getters.get_selJob"
                    :key="i"
                  >
                    <v-list-item-icon
                      ><v-btn color="error" @click="delSelJob(i)"
                        ><v-icon left>mdi-delete-empty-outline</v-icon>ลบ</v-btn
                      >
                      <v-icon>mdi-pan-right</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="
                          item.job_name +
                            ' <b>เพศ :</b> ' +
                            item.e_job_sex_name +
                            ' <b>การศึกษา :</b> ' +
                            item.edu_level
                        "
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="$store.state.dataFrm.tea_salary"
              label="อัตราเงินเดือนที่ต้องการ"
              type="number"
              required
            ></v-text-field>
          </v-col>
        </v-col>
        <v-col cols="12" md="6">
          <v-row cols="12" justify="center" class="pt-2">
            <v-sheet
              color="grey darken-2"
              elevation="1"
              max-height="240"
              max-width="180"
              rounded
            >
              <v-img
                :lazy-src="url"
                max-height="240"
                max-width="180"
                :src="url"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-sheet>
          </v-row>
          <v-row cols="12">
            <v-file-input
              show-size
              v-model="$store.state.dataFrm.tea_regis_photo"
              truncate-length="15"
              accept="image/*"
              label="ภาพถ่ายหน้าตรง ไม่สวมหมวก แว่นตาดำ"
              @change="onFileChange($event)"
            ></v-file-input>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <v-dialog v-model="dialog_showjob" max-width="1200px">
      <Home show_select="true"></Home>
    </v-dialog>
  </v-card>
</template>

<script>
import Home from "../views/Home";
var noProfile = require("@/assets/images/noProfile.jpg");
export default {
  components: { Home },
  data() {
    return {
      dialog_showjob: false,
      url:
        this.$store.state.dataFrm.fileFromLoad.tea_regis_photo == ""
          ? noProfile
          : process.env.VUE_APP_PATHAPP +
            `/file_doc/` +
            this.$store.state.dataFrm.fileFromLoad.tea_regis_photo +
            "?" +
            Date.now(),
      //tea_data:null,
    };
  },
  mounted() {
    // if (this.$store.getters.get_selJob.length > 0) {
    //   if (this.$store.state.dataFrm.tea_regis_photo !== null) {
    //     this.onFileChange(this.$store.state.dataFrm.tea_regis_photo);
    //   }
    //   //this.tea_data=this.$store.getters.get_userRegis[0]
    //     // console.log(this.$store.getters.userRegis);
    // }
    // else{
    //   //this.$router.push('');
    // }
    // console.log(this.url);
  },
  props: {
    label: {
      type: String,
      default: "",
    },
  },
  methods: {
    onFileChange($event) {
      // console.log($event);
      if ($event != null) {
        const file = $event;
        this.url = URL.createObjectURL(file);
        this.$store.state.dataFrm.tea_regis_photo = file;
      } else {
        this.$store.state.dataFrm.tea_regis_photo = null;
        this.url = noProfile;
      }
    },
    delSelJob(val) {
      this.$store.dispatch("del_selJob", val);
    },
  },
};
</script>

<style></style>
